module.exports = __webpack_public_path__ + "img/emptyjob.2e2afced.svg";